import React from 'react';
import "./Alert.scss";
import { connect } from 'react-redux'

class _Alert extends React.Component {

    showPop = (visible) => {
        // setTimeout(() => {
        this.setState({ modalVisible: visible });
        console.log(this.state);
        // },2000);
    }
    componentDidMount() {
        // this.showPop();
    }
    render() {
        const { title, content, show, onOk, onCancel } = this.alert.alert
        if (!show) {
            return null
        }

        return (
            <div><h2>{title}</h2><p>{content}</p></div>
        )
    }
}

// Subscribe 
const map = state => {
    return {
        alert: state.alert.alert
    }
}
const Alert = connect(map)(_Alert)

Alert.alert = function(title, content) {
    store.dispatch({ type: "ALERT", title: "some tilel", content: "some content", show: true })

}
module.exports = Alert;
